// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/bg/logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-master {
    background-color: #eaf3f8;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }
  
  .product-master .div {
    background-color: #eaf3f8;
    border: 1px none;
    height: 1080px;
    overflow: hidden;
    position: relative;
    width: 1920px;
  }
  
  .product-master .navbar {
    height: 70px;
    left: 32px;
    position: absolute;
    top: 170px;
    width: 1857px;
  }
  
  .product-master .table {
    height: 70px;
    left: 0;
    position: absolute;
    top: 0;
    width: 1857px;
  }
  
  .product-master .header-tabel {
    height: 70px;
    position: relative;
  }
  
  .product-master .rectangle {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 0;
    position: absolute;
    top: 0;
    width: 131px;
  }
  
  .product-master .rectangle-2 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 136px;
    position: absolute;
    top: 0;
    width: 223px;
  }
  
  .product-master .rectangle-3 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 649px;
    position: absolute;
    top: 0;
    width: 240px;
  }
  
  .product-master .rectangle-4 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 1677px;
    position: absolute;
    top: 0;
    width: 180px;
  }
  
  .product-master .rectangle-5 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 1070px;
    position: absolute;
    top: 0;
    width: 221px;
  }
  
  .product-master .rectangle-6 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 1296px;
    position: absolute;
    top: 0;
    width: 213px;
  }
  
  .product-master .rectangle-7 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 1512px;
    position: absolute;
    top: 0;
    width: 160px;
  }
  
  .product-master .rectangle-8 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 893px;
    position: absolute;
    top: 0;
    width: 173px;
  }
  
  .product-master .rectangle-9 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 364px;
    position: absolute;
    top: 0;
    width: 280px;
  }
  
  .product-master .text-wrapper {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 22px;
    font-weight: 500;
    left: 390px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .product-master .text-wrapper-2 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 22px;
    font-weight: 500;
    left: 50px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .product-master .text-wrapper-3 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 22px;
    font-weight: 500;
    left: 160px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .product-master .PRINCIPAL-NAME {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 22px;
    font-weight: 500;
    left: 925px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 6px;
  }
  
  .product-master .text-wrapper-4 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 22px;
    font-weight: 500;
    left: 1111px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .product-master .text-wrapper-5 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 22px;
    font-weight: 500;
    left: 1320px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .product-master .text-wrapper-6 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 22px;
    font-weight: 500;
    left: 658px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .product-master .text-wrapper-7 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 22px;
    font-weight: 500;
    left: 1537px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .product-master .text-wrapper-8 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 22px;
    font-weight: 500;
    left: 1728px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .product-master .overlap {
    background-color: #ffffff;
    border: 1px solid;
    border-color: #d9d9d9;
    height: 102px;
    left: -1px;
    position: absolute;
    top: -1px;
    width: 1922px;
  }
  
  .product-master .header-DATA {
    color: #000000;
    font-family: "Red Hat Display-Bold", Helvetica;
    font-size: 24px;
    font-weight: 700;
    left: 115px;
    letter-spacing: 0.24px;
    line-height: normal;
    position: absolute;
    top: 33px;
  }
  
  .product-master .logo-SIVINA {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 100% 100%;
    height: 60px;
    left: 35px;
    position: absolute;
    top: 20px;
    width: 60px;
  }
  
  .product-master .action-project {
    color: #000000;
    font-family: "Montserrat-SemiBold", Helvetica;
    font-size: 24px;
    font-weight: 600;
    left: 1329px;
    letter-spacing: 0.48px;
    line-height: normal;
    position: absolute;
    top: 35px;
  }
  
  .product-master .action-dashboard {
    color: #000000;
    font-family: "Montserrat-Regular", Helvetica;
    font-size: 24px;
    font-weight: 400;
    left: 1650px;
    letter-spacing: 0.48px;
    line-height: normal;
    position: absolute;
    top: 35px;
  }
  
  .product-master .profile-icon {
    background-color: #49bc92;
    border-radius: 25px;
    height: 50px;
    left: 1840px;
    position: absolute;
    top: 25px;
    width: 50px;
  }
  
  .product-master .s {
    height: 18px;
    left: 19px;
    position: absolute;
    top: 16px;
    width: 13px;
  }
  
  .product-master .caption-menampilkan {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 24px;
    font-weight: 500;
    left: 813px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 1030px;
    white-space: nowrap;
  }
  
  .product-master .page {
    height: 35px;
    left: 1640px;
    position: absolute;
    top: 1027px;
    width: 257px;
  }
  
  .product-master .text-wrapper-9 {
    color: #000000;
    font-family: "Roboto-Light", Helvetica;
    font-size: 24px;
    font-weight: 300;
    left: 45px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 4px;
    white-space: nowrap;
  }
  
  .product-master .text-wrapper-10 {
    color: #000000;
    font-family: "Roboto-SemiBold", Helvetica;
    font-size: 24px;
    font-weight: 600;
    left: 0;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 4px;
    white-space: nowrap;
  }
  
  .product-master .button-next {
    height: 35px;
    left: 169px;
    position: absolute;
    top: 0;
    width: 37px;
  }
  
  .product-master .overlap-group {
    background-color: #069dae;
    border-radius: 5px;
    height: 35px;
    position: relative;
    width: 35px;
  }
  
  .product-master .text-wrapper-11 {
    color: #ffffff;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 24px;
    font-weight: 400;
    left: 11px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 4px;
    white-space: nowrap;
  }
  
  .product-master .text-wrapper-12 {
    color: #000000;
    font-family: "Roboto-Light", Helvetica;
    font-size: 24px;
    font-weight: 300;
    left: 87px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 4px;
    white-space: nowrap;
  }
  
  .product-master .text-wrapper-13 {
    color: #000000;
    font-family: "Roboto-Light", Helvetica;
    font-size: 24px;
    font-weight: 300;
    left: 135px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 3px;
    white-space: nowrap;
  }
  
  .product-master .button-end {
    height: 35px;
    left: 214px;
    position: absolute;
    top: 0;
    width: 37px;
  }
  
  .product-master .text-wrapper-14 {
    color: #ffffff;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 24px;
    font-weight: 400;
    left: 11px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 2px;
    white-space: nowrap;
  }
  
  .product-master .vector-stroke {
    height: 6px;
    left: 13px;
    position: absolute;
    top: 19px;
    width: 10px;
  }
  
  .product-master .action-filter {
    height: 40px;
    left: 499px;
    position: absolute;
    top: 115px;
    width: 323px;
  }
  
  .product-master .overlap-2 {
    background-color: #ffffff;
    border: 3px solid;
    border-color: #069dae;
    border-radius: 5px;
    height: 40px;
    position: relative;
    width: 321px;
  }
  
  .product-master .polygon {
    height: 13px;
    left: 291px;
    position: absolute;
    top: 10px;
    width: 15px;
  }
  
  .product-master .text-wrapper-15 {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 11px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 5px;
    white-space: nowrap;
  }
  
  .product-master .baris-isi {
    height: 765px;
    left: 35px;
    overflow: hidden;
    overflow-y: scroll;
    position: absolute;
    top: 251px;
    width: 1857px;
  }
  
  .product-master .div-wrapper {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 0;
    width: 131px;
  }
  
  .product-master .text-wrapper-16 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 59px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .product-master .overlap-3 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 0;
    width: 220px;
  }
  
  .product-master .text-wrapper-17 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 30px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .product-master .overlap-4 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 0;
    width: 240px;
  }
  
  .product-master .text-wrapper-18 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 20px;
    font-weight: 400;
    left: 47px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 13px;
    white-space: nowrap;
  }
  
  .product-master .rectangle-10 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 0;
    width: 180px;
  }
  
  .product-master .overlap-5 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 0;
    width: 173px;
  }
  
  .product-master .text-wrapper-19 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 22px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .product-master .overlap-6 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 0;
    width: 221px;
  }
  
  .product-master .text-wrapper-20 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 20px;
    font-weight: 400;
    left: 65px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 11px;
    white-space: nowrap;
  }
  
  .product-master .overlap-7 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 0;
    width: 163px;
  }
  
  .product-master .text-wrapper-21 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 20px;
    font-weight: 400;
    left: 18px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 11px;
    white-space: nowrap;
  }
  
  .product-master .overlap-8 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 0;
    width: 211px;
  }
  
  .product-master .text-wrapper-22 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 20px;
    font-weight: 400;
    left: 20px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 11px;
    white-space: nowrap;
  }
  
  .product-master .overlap-9 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 0;
    width: 280px;
  }
  
  .product-master .text-wrapper-23 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 38px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .product-master .overlap-10 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 55px;
    width: 131px;
  }
  
  .product-master .overlap-11 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 55px;
    width: 220px;
  }
  
  .product-master .overlap-12 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 55px;
    width: 240px;
  }
  
  .product-master .text-wrapper-24 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 20px;
    font-weight: 400;
    left: 47px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 14px;
    white-space: nowrap;
  }
  
  .product-master .rectangle-11 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 55px;
    width: 180px;
  }
  
  .product-master .overlap-13 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 55px;
    width: 173px;
  }
  
  .product-master .overlap-14 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 55px;
    width: 221px;
  }
  
  .product-master .text-wrapper-25 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 20px;
    font-weight: 400;
    left: 68px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 13px;
    white-space: nowrap;
  }
  
  .product-master .overlap-15 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 55px;
    width: 163px;
  }
  
  .product-master .text-wrapper-26 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 20px;
    font-weight: 400;
    left: 73px;
    letter-spacing: 0.6px;
    line-height: normal;
    position: absolute;
    top: 14px;
    white-space: nowrap;
  }
  
  .product-master .overlap-16 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 55px;
    width: 211px;
  }
  
  .product-master .text-wrapper-27 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 20px;
    font-weight: 400;
    left: 37px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 13px;
    white-space: nowrap;
  }
  
  .product-master .overlap-17 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 55px;
    width: 280px;
  }
  
  .product-master .text-wrapper-28 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 79px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .product-master .overlap-18 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 110px;
    width: 131px;
  }
  
  .product-master .overlap-19 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 110px;
    width: 220px;
  }
  
  .product-master .overlap-20 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 110px;
    width: 240px;
  }
  
  .product-master .rectangle-12 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 110px;
    width: 180px;
  }
  
  .product-master .overlap-21 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 110px;
    width: 173px;
  }
  
  .product-master .overlap-22 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 110px;
    width: 221px;
  }
  
  .product-master .text-wrapper-29 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 20px;
    font-weight: 400;
    left: 78px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 13px;
    white-space: nowrap;
  }
  
  .product-master .overlap-23 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 110px;
    width: 163px;
  }
  
  .product-master .text-wrapper-30 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 20px;
    font-weight: 400;
    left: 73px;
    letter-spacing: 0.6px;
    line-height: normal;
    position: absolute;
    top: 13px;
    white-space: nowrap;
  }
  
  .product-master .overlap-24 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 110px;
    width: 211px;
  }
  
  .product-master .overlap-25 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 110px;
    width: 280px;
  }
  
  .product-master .text-wrapper-31 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 78px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .product-master .overlap-26 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 165px;
    width: 131px;
  }
  
  .product-master .overlap-27 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 220px;
    width: 131px;
  }
  
  .product-master .rectangle-13 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 275px;
    width: 131px;
  }
  
  .product-master .rectangle-14 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 330px;
    width: 131px;
  }
  
  .product-master .rectangle-15 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 385px;
    width: 131px;
  }
  
  .product-master .rectangle-16 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 440px;
    width: 131px;
  }
  
  .product-master .rectangle-17 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 495px;
    width: 131px;
  }
  
  .product-master .rectangle-18 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 550px;
    width: 131px;
  }
  
  .product-master .rectangle-19 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 605px;
    width: 131px;
  }
  
  .product-master .rectangle-20 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 660px;
    width: 131px;
  }
  
  .product-master .rectangle-21 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 715px;
    width: 131px;
  }
  
  .product-master .rectangle-22 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 770px;
    width: 131px;
  }
  
  .product-master .overlap-28 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 165px;
    width: 220px;
  }
  
  .product-master .overlap-29 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 220px;
    width: 220px;
  }
  
  .product-master .rectangle-23 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 275px;
    width: 220px;
  }
  
  .product-master .rectangle-24 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 330px;
    width: 220px;
  }
  
  .product-master .rectangle-25 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 385px;
    width: 220px;
  }
  
  .product-master .rectangle-26 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 440px;
    width: 220px;
  }
  
  .product-master .rectangle-27 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 495px;
    width: 220px;
  }
  
  .product-master .rectangle-28 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 550px;
    width: 220px;
  }
  
  .product-master .rectangle-29 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 605px;
    width: 220px;
  }
  
  .product-master .rectangle-30 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 660px;
    width: 220px;
  }
  
  .product-master .rectangle-31 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 715px;
    width: 220px;
  }
  
  .product-master .rectangle-32 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 770px;
    width: 220px;
  }
  
  .product-master .overlap-30 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 165px;
    width: 240px;
  }
  
  .product-master .overlap-31 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 220px;
    width: 240px;
  }
  
  .product-master .rectangle-33 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 275px;
    width: 240px;
  }
  
  .product-master .rectangle-34 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 330px;
    width: 240px;
  }
  
  .product-master .rectangle-35 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 385px;
    width: 240px;
  }
  
  .product-master .rectangle-36 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 440px;
    width: 240px;
  }
  
  .product-master .rectangle-37 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 495px;
    width: 240px;
  }
  
  .product-master .rectangle-38 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 550px;
    width: 240px;
  }
  
  .product-master .rectangle-39 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 605px;
    width: 240px;
  }
  
  .product-master .rectangle-40 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 660px;
    width: 240px;
  }
  
  .product-master .rectangle-41 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 715px;
    width: 240px;
  }
  
  .product-master .rectangle-42 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 770px;
    width: 240px;
  }
  
  .product-master .rectangle-43 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 165px;
    width: 180px;
  }
  
  .product-master .rectangle-44 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 220px;
    width: 180px;
  }
  
  .product-master .rectangle-45 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 275px;
    width: 180px;
  }
  
  .product-master .rectangle-46 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 330px;
    width: 180px;
  }
  
  .product-master .rectangle-47 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 385px;
    width: 180px;
  }
  
  .product-master .rectangle-48 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 440px;
    width: 180px;
  }
  
  .product-master .rectangle-49 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 495px;
    width: 180px;
  }
  
  .product-master .rectangle-50 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 550px;
    width: 180px;
  }
  
  .product-master .rectangle-51 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 605px;
    width: 180px;
  }
  
  .product-master .rectangle-52 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 660px;
    width: 180px;
  }
  
  .product-master .rectangle-53 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 715px;
    width: 180px;
  }
  
  .product-master .rectangle-54 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 770px;
    width: 180px;
  }
  
  .product-master .overlap-32 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 165px;
    width: 173px;
  }
  
  .product-master .overlap-33 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 165px;
    width: 221px;
  }
  
  .product-master .text-wrapper-32 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 20px;
    font-weight: 400;
    left: 65px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 14px;
    white-space: nowrap;
  }
  
  .product-master .overlap-34 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 220px;
    width: 173px;
  }
  
  .product-master .overlap-35 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 220px;
    width: 221px;
  }
  
  .product-master .rectangle-55 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 275px;
    width: 173px;
  }
  
  .product-master .rectangle-56 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 275px;
    width: 221px;
  }
  
  .product-master .rectangle-57 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 330px;
    width: 173px;
  }
  
  .product-master .rectangle-58 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 330px;
    width: 221px;
  }
  
  .product-master .rectangle-59 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 385px;
    width: 173px;
  }
  
  .product-master .rectangle-60 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 385px;
    width: 221px;
  }
  
  .product-master .rectangle-61 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 440px;
    width: 173px;
  }
  
  .product-master .rectangle-62 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 440px;
    width: 221px;
  }
  
  .product-master .rectangle-63 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 495px;
    width: 173px;
  }
  
  .product-master .rectangle-64 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 495px;
    width: 221px;
  }
  
  .product-master .rectangle-65 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 550px;
    width: 173px;
  }
  
  .product-master .rectangle-66 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 550px;
    width: 221px;
  }
  
  .product-master .rectangle-67 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 605px;
    width: 173px;
  }
  
  .product-master .rectangle-68 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 605px;
    width: 221px;
  }
  
  .product-master .rectangle-69 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 660px;
    width: 173px;
  }
  
  .product-master .rectangle-70 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 660px;
    width: 221px;
  }
  
  .product-master .rectangle-71 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 715px;
    width: 173px;
  }
  
  .product-master .rectangle-72 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 715px;
    width: 221px;
  }
  
  .product-master .rectangle-73 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 770px;
    width: 173px;
  }
  
  .product-master .rectangle-74 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 770px;
    width: 221px;
  }
  
  .product-master .overlap-36 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 165px;
    width: 163px;
  }
  
  .product-master .overlap-37 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 220px;
    width: 163px;
  }
  
  .product-master .rectangle-75 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 275px;
    width: 163px;
  }
  
  .product-master .rectangle-76 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 330px;
    width: 163px;
  }
  
  .product-master .rectangle-77 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 385px;
    width: 163px;
  }
  
  .product-master .rectangle-78 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 440px;
    width: 163px;
  }
  
  .product-master .rectangle-79 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 495px;
    width: 163px;
  }
  
  .product-master .rectangle-80 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 550px;
    width: 163px;
  }
  
  .product-master .rectangle-81 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 605px;
    width: 163px;
  }
  
  .product-master .rectangle-82 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 660px;
    width: 163px;
  }
  
  .product-master .rectangle-83 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 715px;
    width: 163px;
  }
  
  .product-master .rectangle-84 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 770px;
    width: 163px;
  }
  
  .product-master .overlap-38 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 165px;
    width: 211px;
  }
  
  .product-master .text-wrapper-33 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 20px;
    font-weight: 400;
    left: 20px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 14px;
    white-space: nowrap;
  }
  
  .product-master .overlap-39 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 220px;
    width: 211px;
  }
  
  .product-master .rectangle-85 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 275px;
    width: 211px;
  }
  
  .product-master .rectangle-86 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 330px;
    width: 211px;
  }
  
  .product-master .rectangle-87 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 385px;
    width: 211px;
  }
  
  .product-master .rectangle-88 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 440px;
    width: 211px;
  }
  
  .product-master .rectangle-89 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 495px;
    width: 211px;
  }
  
  .product-master .rectangle-90 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 550px;
    width: 211px;
  }
  
  .product-master .rectangle-91 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 605px;
    width: 211px;
  }
  
  .product-master .rectangle-92 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 660px;
    width: 211px;
  }
  
  .product-master .rectangle-93 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 715px;
    width: 211px;
  }
  
  .product-master .rectangle-94 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 770px;
    width: 211px;
  }
  
  .product-master .overlap-40 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 165px;
    width: 280px;
  }
  
  .product-master .text-wrapper-34 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 57px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .product-master .overlap-41 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 220px;
    width: 280px;
  }
  
  .product-master .rectangle-95 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 275px;
    width: 280px;
  }
  
  .product-master .rectangle-96 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 330px;
    width: 280px;
  }
  
  .product-master .rectangle-97 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 385px;
    width: 280px;
  }
  
  .product-master .rectangle-98 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 440px;
    width: 280px;
  }
  
  .product-master .rectangle-99 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 495px;
    width: 280px;
  }
  
  .product-master .rectangle-100 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 550px;
    width: 280px;
  }
  
  .product-master .rectangle-101 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 605px;
    width: 280px;
  }
  
  .product-master .rectangle-102 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 660px;
    width: 280px;
  }
  
  .product-master .rectangle-103 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 715px;
    width: 280px;
  }
  
  .product-master .rectangle-104 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 770px;
    width: 280px;
  }
  
  .product-master .rectangle-105 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 825px;
    width: 131px;
  }
  
  .product-master .rectangle-106 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 825px;
    width: 220px;
  }
  
  .product-master .rectangle-107 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 825px;
    width: 240px;
  }
  
  .product-master .rectangle-108 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 825px;
    width: 180px;
  }
  
  .product-master .rectangle-109 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 825px;
    width: 173px;
  }
  
  .product-master .rectangle-110 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 825px;
    width: 221px;
  }
  
  .product-master .rectangle-111 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 825px;
    width: 163px;
  }
  
  .product-master .rectangle-112 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 825px;
    width: 211px;
  }
  
  .product-master .rectangle-113 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 825px;
    width: 280px;
  }
  
  .product-master .rectangle-114 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 880px;
    width: 131px;
  }
  
  .product-master .rectangle-115 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 935px;
    width: 131px;
  }
  
  .product-master .rectangle-116 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 990px;
    width: 131px;
  }
  
  .product-master .rectangle-117 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1045px;
    width: 131px;
  }
  
  .product-master .rectangle-118 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1100px;
    width: 131px;
  }
  
  .product-master .rectangle-119 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1155px;
    width: 131px;
  }
  
  .product-master .rectangle-120 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1210px;
    width: 131px;
  }
  
  .product-master .rectangle-121 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1265px;
    width: 131px;
  }
  
  .product-master .rectangle-122 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1320px;
    width: 131px;
  }
  
  .product-master .rectangle-123 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 880px;
    width: 220px;
  }
  
  .product-master .rectangle-124 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 935px;
    width: 220px;
  }
  
  .product-master .rectangle-125 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 990px;
    width: 220px;
  }
  
  .product-master .rectangle-126 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1045px;
    width: 220px;
  }
  
  .product-master .rectangle-127 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1100px;
    width: 220px;
  }
  
  .product-master .rectangle-128 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1155px;
    width: 220px;
  }
  
  .product-master .rectangle-129 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1210px;
    width: 220px;
  }
  
  .product-master .rectangle-130 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1265px;
    width: 220px;
  }
  
  .product-master .rectangle-131 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1320px;
    width: 220px;
  }
  
  .product-master .rectangle-132 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 880px;
    width: 240px;
  }
  
  .product-master .rectangle-133 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 935px;
    width: 240px;
  }
  
  .product-master .rectangle-134 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 990px;
    width: 240px;
  }
  
  .product-master .rectangle-135 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 1045px;
    width: 240px;
  }
  
  .product-master .rectangle-136 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 1100px;
    width: 240px;
  }
  
  .product-master .rectangle-137 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 1155px;
    width: 240px;
  }
  
  .product-master .rectangle-138 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 1210px;
    width: 240px;
  }
  
  .product-master .rectangle-139 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 1265px;
    width: 240px;
  }
  
  .product-master .rectangle-140 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 646px;
    position: absolute;
    top: 1320px;
    width: 240px;
  }
  
  .product-master .rectangle-141 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 880px;
    width: 180px;
  }
  
  .product-master .rectangle-142 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 935px;
    width: 180px;
  }
  
  .product-master .rectangle-143 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 990px;
    width: 180px;
  }
  
  .product-master .rectangle-144 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1045px;
    width: 180px;
  }
  
  .product-master .rectangle-145 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1100px;
    width: 180px;
  }
  
  .product-master .rectangle-146 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1155px;
    width: 180px;
  }
  
  .product-master .rectangle-147 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1210px;
    width: 180px;
  }
  
  .product-master .rectangle-148 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1265px;
    width: 180px;
  }
  
  .product-master .rectangle-149 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1320px;
    width: 180px;
  }
  
  .product-master .rectangle-150 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 880px;
    width: 173px;
  }
  
  .product-master .rectangle-151 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 880px;
    width: 221px;
  }
  
  .product-master .rectangle-152 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 935px;
    width: 173px;
  }
  
  .product-master .rectangle-153 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 935px;
    width: 221px;
  }
  
  .product-master .rectangle-154 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 990px;
    width: 173px;
  }
  
  .product-master .rectangle-155 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 990px;
    width: 221px;
  }
  
  .product-master .rectangle-156 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 1045px;
    width: 173px;
  }
  
  .product-master .rectangle-157 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 1045px;
    width: 221px;
  }
  
  .product-master .rectangle-158 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 1100px;
    width: 173px;
  }
  
  .product-master .rectangle-159 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 1100px;
    width: 221px;
  }
  
  .product-master .rectangle-160 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 1155px;
    width: 173px;
  }
  
  .product-master .rectangle-161 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 1155px;
    width: 221px;
  }
  
  .product-master .rectangle-162 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 1210px;
    width: 173px;
  }
  
  .product-master .rectangle-163 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 1210px;
    width: 221px;
  }
  
  .product-master .rectangle-164 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 1265px;
    width: 173px;
  }
  
  .product-master .rectangle-165 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 1265px;
    width: 221px;
  }
  
  .product-master .rectangle-166 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 890px;
    position: absolute;
    top: 1320px;
    width: 173px;
  }
  
  .product-master .rectangle-167 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1067px;
    position: absolute;
    top: 1320px;
    width: 221px;
  }
  
  .product-master .rectangle-168 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 880px;
    width: 163px;
  }
  
  .product-master .rectangle-169 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 935px;
    width: 163px;
  }
  
  .product-master .rectangle-170 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 990px;
    width: 163px;
  }
  
  .product-master .rectangle-171 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 1045px;
    width: 163px;
  }
  
  .product-master .rectangle-172 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 1100px;
    width: 163px;
  }
  
  .product-master .rectangle-173 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 1155px;
    width: 163px;
  }
  
  .product-master .rectangle-174 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 1210px;
    width: 163px;
  }
  
  .product-master .rectangle-175 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 1265px;
    width: 163px;
  }
  
  .product-master .rectangle-176 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1509px;
    position: absolute;
    top: 1320px;
    width: 163px;
  }
  
  .product-master .rectangle-177 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 880px;
    width: 211px;
  }
  
  .product-master .rectangle-178 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 935px;
    width: 211px;
  }
  
  .product-master .rectangle-179 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 990px;
    width: 211px;
  }
  
  .product-master .rectangle-180 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 1045px;
    width: 211px;
  }
  
  .product-master .rectangle-181 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 1100px;
    width: 211px;
  }
  
  .product-master .rectangle-182 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 1155px;
    width: 211px;
  }
  
  .product-master .rectangle-183 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 1210px;
    width: 211px;
  }
  
  .product-master .rectangle-184 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 1265px;
    width: 211px;
  }
  
  .product-master .rectangle-185 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1293px;
    position: absolute;
    top: 1320px;
    width: 211px;
  }
  
  .product-master .rectangle-186 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 880px;
    width: 280px;
  }
  
  .product-master .rectangle-187 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 935px;
    width: 280px;
  }
  
  .product-master .rectangle-188 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 990px;
    width: 280px;
  }
  
  .product-master .rectangle-189 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 1045px;
    width: 280px;
  }
  
  .product-master .rectangle-190 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 1100px;
    width: 280px;
  }
  
  .product-master .rectangle-191 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 1155px;
    width: 280px;
  }
  
  .product-master .rectangle-192 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 1210px;
    width: 280px;
  }
  
  .product-master .rectangle-193 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 1265px;
    width: 280px;
  }
  
  .product-master .rectangle-194 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 1320px;
    width: 280px;
  }
  
  .product-master .action-search {
    height: 40px;
    left: 32px;
    position: absolute;
    top: 117px;
    width: 464px;
  }
  
  .product-master .overlap-42 {
    background-color: #ffffff;
    border: 3px solid;
    border-color: #069dae;
    border-radius: 5px;
    height: 40px;
    position: relative;
    width: 462px;
  }
  
  .product-master .union {
    height: 17px;
    left: 428px;
    position: absolute;
    top: 8px;
    width: 17px;
  }
  
  .product-master .button-add-new {
    height: 40px;
    left: 1640px;
    position: absolute;
    top: 115px;
    width: 252px;
  }
  
  .product-master .overlap-43 {
    background-color: #069dae;
    border-radius: 5px;
    height: 40px;
    position: relative;
    width: 250px;
  }
  
  .product-master .text-wrapper-35 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 17px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 8px;
    white-space: nowrap;
  }
  
  .product-master .overlap-wrapper {
    height: 40px;
    left: 1403px;
    position: absolute;
    top: 115px;
    width: 222px;
  }
  
  .product-master .overlap-44 {
    background-color: #069dae;
    border-radius: 5px;
    height: 40px;
    position: relative;
    width: 220px;
  }
  
  .product-master .text-wrapper-36 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 18px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 8px;
    white-space: nowrap;
  }
  
  .product-master .overlap-group-wrapper {
    height: 40px;
    left: 1170px;
    position: absolute;
    top: 115px;
    width: 222px;
  }
  
  .product-master .text-wrapper-37 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 48px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 8px;
    white-space: nowrap;
  }
  `, "",{"version":3,"sources":["webpack://./src/style/master.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,cAAc;IACd,8CAA8C;IAC9C,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,yDAAmD;IACnD,0BAA0B;IAC1B,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,cAAc;IACd,6CAA6C;IAC7C,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,OAAO;IACP,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB","sourcesContent":[".product-master {\n    background-color: #eaf3f8;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    width: 100%;\n  }\n  \n  .product-master .div {\n    background-color: #eaf3f8;\n    border: 1px none;\n    height: 1080px;\n    overflow: hidden;\n    position: relative;\n    width: 1920px;\n  }\n  \n  .product-master .navbar {\n    height: 70px;\n    left: 32px;\n    position: absolute;\n    top: 170px;\n    width: 1857px;\n  }\n  \n  .product-master .table {\n    height: 70px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 1857px;\n  }\n  \n  .product-master .header-tabel {\n    height: 70px;\n    position: relative;\n  }\n  \n  .product-master .rectangle {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-2 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 136px;\n    position: absolute;\n    top: 0;\n    width: 223px;\n  }\n  \n  .product-master .rectangle-3 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 649px;\n    position: absolute;\n    top: 0;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-4 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 1677px;\n    position: absolute;\n    top: 0;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-5 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 1070px;\n    position: absolute;\n    top: 0;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-6 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 1296px;\n    position: absolute;\n    top: 0;\n    width: 213px;\n  }\n  \n  .product-master .rectangle-7 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 1512px;\n    position: absolute;\n    top: 0;\n    width: 160px;\n  }\n  \n  .product-master .rectangle-8 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 893px;\n    position: absolute;\n    top: 0;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-9 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 364px;\n    position: absolute;\n    top: 0;\n    width: 280px;\n  }\n  \n  .product-master .text-wrapper {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 22px;\n    font-weight: 500;\n    left: 390px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .product-master .text-wrapper-2 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 22px;\n    font-weight: 500;\n    left: 50px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .product-master .text-wrapper-3 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 22px;\n    font-weight: 500;\n    left: 160px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .product-master .PRINCIPAL-NAME {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 22px;\n    font-weight: 500;\n    left: 925px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 6px;\n  }\n  \n  .product-master .text-wrapper-4 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 22px;\n    font-weight: 500;\n    left: 1111px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .product-master .text-wrapper-5 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 22px;\n    font-weight: 500;\n    left: 1320px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .product-master .text-wrapper-6 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 22px;\n    font-weight: 500;\n    left: 658px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .product-master .text-wrapper-7 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 22px;\n    font-weight: 500;\n    left: 1537px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .product-master .text-wrapper-8 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 22px;\n    font-weight: 500;\n    left: 1728px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap {\n    background-color: #ffffff;\n    border: 1px solid;\n    border-color: #d9d9d9;\n    height: 102px;\n    left: -1px;\n    position: absolute;\n    top: -1px;\n    width: 1922px;\n  }\n  \n  .product-master .header-DATA {\n    color: #000000;\n    font-family: \"Red Hat Display-Bold\", Helvetica;\n    font-size: 24px;\n    font-weight: 700;\n    left: 115px;\n    letter-spacing: 0.24px;\n    line-height: normal;\n    position: absolute;\n    top: 33px;\n  }\n  \n  .product-master .logo-SIVINA {\n    background-image: url(../assets/images/bg/logo.png);\n    background-size: 100% 100%;\n    height: 60px;\n    left: 35px;\n    position: absolute;\n    top: 20px;\n    width: 60px;\n  }\n  \n  .product-master .action-project {\n    color: #000000;\n    font-family: \"Montserrat-SemiBold\", Helvetica;\n    font-size: 24px;\n    font-weight: 600;\n    left: 1329px;\n    letter-spacing: 0.48px;\n    line-height: normal;\n    position: absolute;\n    top: 35px;\n  }\n  \n  .product-master .action-dashboard {\n    color: #000000;\n    font-family: \"Montserrat-Regular\", Helvetica;\n    font-size: 24px;\n    font-weight: 400;\n    left: 1650px;\n    letter-spacing: 0.48px;\n    line-height: normal;\n    position: absolute;\n    top: 35px;\n  }\n  \n  .product-master .profile-icon {\n    background-color: #49bc92;\n    border-radius: 25px;\n    height: 50px;\n    left: 1840px;\n    position: absolute;\n    top: 25px;\n    width: 50px;\n  }\n  \n  .product-master .s {\n    height: 18px;\n    left: 19px;\n    position: absolute;\n    top: 16px;\n    width: 13px;\n  }\n  \n  .product-master .caption-menampilkan {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 24px;\n    font-weight: 500;\n    left: 813px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 1030px;\n    white-space: nowrap;\n  }\n  \n  .product-master .page {\n    height: 35px;\n    left: 1640px;\n    position: absolute;\n    top: 1027px;\n    width: 257px;\n  }\n  \n  .product-master .text-wrapper-9 {\n    color: #000000;\n    font-family: \"Roboto-Light\", Helvetica;\n    font-size: 24px;\n    font-weight: 300;\n    left: 45px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 4px;\n    white-space: nowrap;\n  }\n  \n  .product-master .text-wrapper-10 {\n    color: #000000;\n    font-family: \"Roboto-SemiBold\", Helvetica;\n    font-size: 24px;\n    font-weight: 600;\n    left: 0;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 4px;\n    white-space: nowrap;\n  }\n  \n  .product-master .button-next {\n    height: 35px;\n    left: 169px;\n    position: absolute;\n    top: 0;\n    width: 37px;\n  }\n  \n  .product-master .overlap-group {\n    background-color: #069dae;\n    border-radius: 5px;\n    height: 35px;\n    position: relative;\n    width: 35px;\n  }\n  \n  .product-master .text-wrapper-11 {\n    color: #ffffff;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 24px;\n    font-weight: 400;\n    left: 11px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 4px;\n    white-space: nowrap;\n  }\n  \n  .product-master .text-wrapper-12 {\n    color: #000000;\n    font-family: \"Roboto-Light\", Helvetica;\n    font-size: 24px;\n    font-weight: 300;\n    left: 87px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 4px;\n    white-space: nowrap;\n  }\n  \n  .product-master .text-wrapper-13 {\n    color: #000000;\n    font-family: \"Roboto-Light\", Helvetica;\n    font-size: 24px;\n    font-weight: 300;\n    left: 135px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 3px;\n    white-space: nowrap;\n  }\n  \n  .product-master .button-end {\n    height: 35px;\n    left: 214px;\n    position: absolute;\n    top: 0;\n    width: 37px;\n  }\n  \n  .product-master .text-wrapper-14 {\n    color: #ffffff;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 24px;\n    font-weight: 400;\n    left: 11px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 2px;\n    white-space: nowrap;\n  }\n  \n  .product-master .vector-stroke {\n    height: 6px;\n    left: 13px;\n    position: absolute;\n    top: 19px;\n    width: 10px;\n  }\n  \n  .product-master .action-filter {\n    height: 40px;\n    left: 499px;\n    position: absolute;\n    top: 115px;\n    width: 323px;\n  }\n  \n  .product-master .overlap-2 {\n    background-color: #ffffff;\n    border: 3px solid;\n    border-color: #069dae;\n    border-radius: 5px;\n    height: 40px;\n    position: relative;\n    width: 321px;\n  }\n  \n  .product-master .polygon {\n    height: 13px;\n    left: 291px;\n    position: absolute;\n    top: 10px;\n    width: 15px;\n  }\n  \n  .product-master .text-wrapper-15 {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 11px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 5px;\n    white-space: nowrap;\n  }\n  \n  .product-master .baris-isi {\n    height: 765px;\n    left: 35px;\n    overflow: hidden;\n    overflow-y: scroll;\n    position: absolute;\n    top: 251px;\n    width: 1857px;\n  }\n  \n  .product-master .div-wrapper {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 131px;\n  }\n  \n  .product-master .text-wrapper-16 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 59px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap-3 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 0;\n    width: 220px;\n  }\n  \n  .product-master .text-wrapper-17 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 30px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap-4 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 0;\n    width: 240px;\n  }\n  \n  .product-master .text-wrapper-18 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 20px;\n    font-weight: 400;\n    left: 47px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 13px;\n    white-space: nowrap;\n  }\n  \n  .product-master .rectangle-10 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 0;\n    width: 180px;\n  }\n  \n  .product-master .overlap-5 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 0;\n    width: 173px;\n  }\n  \n  .product-master .text-wrapper-19 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 22px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap-6 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 0;\n    width: 221px;\n  }\n  \n  .product-master .text-wrapper-20 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 20px;\n    font-weight: 400;\n    left: 65px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap-7 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 0;\n    width: 163px;\n  }\n  \n  .product-master .text-wrapper-21 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 20px;\n    font-weight: 400;\n    left: 18px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap-8 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 0;\n    width: 211px;\n  }\n  \n  .product-master .text-wrapper-22 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 20px;\n    font-weight: 400;\n    left: 20px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap-9 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 0;\n    width: 280px;\n  }\n  \n  .product-master .text-wrapper-23 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 38px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap-10 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 55px;\n    width: 131px;\n  }\n  \n  .product-master .overlap-11 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 55px;\n    width: 220px;\n  }\n  \n  .product-master .overlap-12 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 55px;\n    width: 240px;\n  }\n  \n  .product-master .text-wrapper-24 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 20px;\n    font-weight: 400;\n    left: 47px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 14px;\n    white-space: nowrap;\n  }\n  \n  .product-master .rectangle-11 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 55px;\n    width: 180px;\n  }\n  \n  .product-master .overlap-13 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 55px;\n    width: 173px;\n  }\n  \n  .product-master .overlap-14 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 55px;\n    width: 221px;\n  }\n  \n  .product-master .text-wrapper-25 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 20px;\n    font-weight: 400;\n    left: 68px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 13px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap-15 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 55px;\n    width: 163px;\n  }\n  \n  .product-master .text-wrapper-26 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 20px;\n    font-weight: 400;\n    left: 73px;\n    letter-spacing: 0.6px;\n    line-height: normal;\n    position: absolute;\n    top: 14px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap-16 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 55px;\n    width: 211px;\n  }\n  \n  .product-master .text-wrapper-27 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 20px;\n    font-weight: 400;\n    left: 37px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 13px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap-17 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 55px;\n    width: 280px;\n  }\n  \n  .product-master .text-wrapper-28 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 79px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap-18 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 110px;\n    width: 131px;\n  }\n  \n  .product-master .overlap-19 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 110px;\n    width: 220px;\n  }\n  \n  .product-master .overlap-20 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 110px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-12 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 110px;\n    width: 180px;\n  }\n  \n  .product-master .overlap-21 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 110px;\n    width: 173px;\n  }\n  \n  .product-master .overlap-22 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 110px;\n    width: 221px;\n  }\n  \n  .product-master .text-wrapper-29 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 20px;\n    font-weight: 400;\n    left: 78px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 13px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap-23 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 110px;\n    width: 163px;\n  }\n  \n  .product-master .text-wrapper-30 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 20px;\n    font-weight: 400;\n    left: 73px;\n    letter-spacing: 0.6px;\n    line-height: normal;\n    position: absolute;\n    top: 13px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap-24 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 110px;\n    width: 211px;\n  }\n  \n  .product-master .overlap-25 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 110px;\n    width: 280px;\n  }\n  \n  .product-master .text-wrapper-31 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 78px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap-26 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 165px;\n    width: 131px;\n  }\n  \n  .product-master .overlap-27 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 220px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-13 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 275px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-14 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 330px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-15 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 385px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-16 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 440px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-17 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 495px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-18 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 550px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-19 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 605px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-20 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 660px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-21 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 715px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-22 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 770px;\n    width: 131px;\n  }\n  \n  .product-master .overlap-28 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 165px;\n    width: 220px;\n  }\n  \n  .product-master .overlap-29 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 220px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-23 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 275px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-24 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 330px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-25 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 385px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-26 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 440px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-27 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 495px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-28 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 550px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-29 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 605px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-30 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 660px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-31 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 715px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-32 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 770px;\n    width: 220px;\n  }\n  \n  .product-master .overlap-30 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 165px;\n    width: 240px;\n  }\n  \n  .product-master .overlap-31 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 220px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-33 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 275px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-34 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 330px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-35 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 385px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-36 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 440px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-37 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 495px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-38 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 550px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-39 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 605px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-40 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 660px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-41 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 715px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-42 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 770px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-43 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 165px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-44 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 220px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-45 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 275px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-46 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 330px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-47 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 385px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-48 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 440px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-49 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 495px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-50 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 550px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-51 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 605px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-52 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 660px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-53 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 715px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-54 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 770px;\n    width: 180px;\n  }\n  \n  .product-master .overlap-32 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 165px;\n    width: 173px;\n  }\n  \n  .product-master .overlap-33 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 165px;\n    width: 221px;\n  }\n  \n  .product-master .text-wrapper-32 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 20px;\n    font-weight: 400;\n    left: 65px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 14px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap-34 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 220px;\n    width: 173px;\n  }\n  \n  .product-master .overlap-35 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 220px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-55 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 275px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-56 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 275px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-57 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 330px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-58 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 330px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-59 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 385px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-60 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 385px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-61 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 440px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-62 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 440px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-63 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 495px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-64 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 495px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-65 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 550px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-66 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 550px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-67 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 605px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-68 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 605px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-69 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 660px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-70 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 660px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-71 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 715px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-72 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 715px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-73 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 770px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-74 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 770px;\n    width: 221px;\n  }\n  \n  .product-master .overlap-36 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 165px;\n    width: 163px;\n  }\n  \n  .product-master .overlap-37 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 220px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-75 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 275px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-76 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 330px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-77 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 385px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-78 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 440px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-79 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 495px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-80 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 550px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-81 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 605px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-82 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 660px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-83 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 715px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-84 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 770px;\n    width: 163px;\n  }\n  \n  .product-master .overlap-38 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 165px;\n    width: 211px;\n  }\n  \n  .product-master .text-wrapper-33 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 20px;\n    font-weight: 400;\n    left: 20px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 14px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap-39 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 220px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-85 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 275px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-86 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 330px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-87 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 385px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-88 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 440px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-89 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 495px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-90 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 550px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-91 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 605px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-92 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 660px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-93 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 715px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-94 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 770px;\n    width: 211px;\n  }\n  \n  .product-master .overlap-40 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 165px;\n    width: 280px;\n  }\n  \n  .product-master .text-wrapper-34 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 57px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap-41 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 220px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-95 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 275px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-96 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 330px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-97 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 385px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-98 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 440px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-99 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 495px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-100 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 550px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-101 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 605px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-102 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 660px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-103 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 715px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-104 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 770px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-105 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 825px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-106 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 825px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-107 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 825px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-108 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 825px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-109 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 825px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-110 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 825px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-111 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 825px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-112 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 825px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-113 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 825px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-114 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 880px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-115 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 935px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-116 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 990px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-117 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1045px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-118 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1100px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-119 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1155px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-120 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1210px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-121 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1265px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-122 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1320px;\n    width: 131px;\n  }\n  \n  .product-master .rectangle-123 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 880px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-124 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 935px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-125 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 990px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-126 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1045px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-127 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1100px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-128 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1155px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-129 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1210px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-130 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1265px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-131 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1320px;\n    width: 220px;\n  }\n  \n  .product-master .rectangle-132 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 880px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-133 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 935px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-134 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 990px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-135 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 1045px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-136 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 1100px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-137 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 1155px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-138 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 1210px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-139 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 1265px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-140 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 646px;\n    position: absolute;\n    top: 1320px;\n    width: 240px;\n  }\n  \n  .product-master .rectangle-141 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 880px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-142 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 935px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-143 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 990px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-144 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1045px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-145 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1100px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-146 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1155px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-147 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1210px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-148 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1265px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-149 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1320px;\n    width: 180px;\n  }\n  \n  .product-master .rectangle-150 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 880px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-151 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 880px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-152 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 935px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-153 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 935px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-154 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 990px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-155 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 990px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-156 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 1045px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-157 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 1045px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-158 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 1100px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-159 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 1100px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-160 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 1155px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-161 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 1155px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-162 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 1210px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-163 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 1210px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-164 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 1265px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-165 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 1265px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-166 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 890px;\n    position: absolute;\n    top: 1320px;\n    width: 173px;\n  }\n  \n  .product-master .rectangle-167 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1067px;\n    position: absolute;\n    top: 1320px;\n    width: 221px;\n  }\n  \n  .product-master .rectangle-168 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 880px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-169 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 935px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-170 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 990px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-171 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 1045px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-172 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 1100px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-173 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 1155px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-174 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 1210px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-175 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 1265px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-176 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1509px;\n    position: absolute;\n    top: 1320px;\n    width: 163px;\n  }\n  \n  .product-master .rectangle-177 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 880px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-178 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 935px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-179 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 990px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-180 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 1045px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-181 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 1100px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-182 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 1155px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-183 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 1210px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-184 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 1265px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-185 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1293px;\n    position: absolute;\n    top: 1320px;\n    width: 211px;\n  }\n  \n  .product-master .rectangle-186 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 880px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-187 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 935px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-188 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 990px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-189 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 1045px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-190 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 1100px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-191 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 1155px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-192 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 1210px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-193 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 1265px;\n    width: 280px;\n  }\n  \n  .product-master .rectangle-194 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 1320px;\n    width: 280px;\n  }\n  \n  .product-master .action-search {\n    height: 40px;\n    left: 32px;\n    position: absolute;\n    top: 117px;\n    width: 464px;\n  }\n  \n  .product-master .overlap-42 {\n    background-color: #ffffff;\n    border: 3px solid;\n    border-color: #069dae;\n    border-radius: 5px;\n    height: 40px;\n    position: relative;\n    width: 462px;\n  }\n  \n  .product-master .union {\n    height: 17px;\n    left: 428px;\n    position: absolute;\n    top: 8px;\n    width: 17px;\n  }\n  \n  .product-master .button-add-new {\n    height: 40px;\n    left: 1640px;\n    position: absolute;\n    top: 115px;\n    width: 252px;\n  }\n  \n  .product-master .overlap-43 {\n    background-color: #069dae;\n    border-radius: 5px;\n    height: 40px;\n    position: relative;\n    width: 250px;\n  }\n  \n  .product-master .text-wrapper-35 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 17px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 8px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap-wrapper {\n    height: 40px;\n    left: 1403px;\n    position: absolute;\n    top: 115px;\n    width: 222px;\n  }\n  \n  .product-master .overlap-44 {\n    background-color: #069dae;\n    border-radius: 5px;\n    height: 40px;\n    position: relative;\n    width: 220px;\n  }\n  \n  .product-master .text-wrapper-36 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 18px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 8px;\n    white-space: nowrap;\n  }\n  \n  .product-master .overlap-group-wrapper {\n    height: 40px;\n    left: 1170px;\n    position: absolute;\n    top: 115px;\n    width: 222px;\n  }\n  \n  .product-master .text-wrapper-37 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 48px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 8px;\n    white-space: nowrap;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
